/**
 * Cookie helpers – shared by turnstile, utm-tracker, consent.
 * @package AdvancedTrackingManager
 */

/**
 * Set a cookie.
 */
export const setCookie = (name: string, value: string, seconds: number): void => {
  const date = new Date();
  date.setTime(date.getTime() + seconds * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/;SameSite=Lax`;
};

/**
 * Get a cookie value by name.
 */
export const getCookie = (name: string): string | null => {
  const row = document.cookie.split('; ').find((r) => r.startsWith(`${name}=`));
  if (!row) return null;
  const value = row.slice(name.length + 1);
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/**
 * Delete a cookie.
 */
export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};
